import { SourceProps, LayerProps } from 'react-map-gl'
import { paint, placesLayout } from './common'

export const placesActiveSource: SourceProps = {
  id: 'places-active',
  type: 'geojson'
}

export const placesActiveLayerStyle: LayerProps = {
  id: 'places-active',
  type: 'symbol',
  source: 'places-active',
  layout: placesLayout,
  paint: paint
}
